import { ReactComponent as TelephoneIcon } from 'images/icons/telephone.svg';
import useTrialExpirationDaysLeft from 'common/components/trial-page/hooks/useTrialExpirationDaysLeft';
import { StyledTrialBanner, StyledBoldText, StyledLinkText, StyledUnderlineLinkText, StyledBodyPadding } from './style';

const TrialBanner = (): JSX.Element | null => {
    const expirationDaysLeft = useTrialExpirationDaysLeft();

    return (
        <StyledTrialBanner>
            <StyledBodyPadding />
            You have
            <StyledBoldText>
                &nbsp;{`${expirationDaysLeft} ${expirationDaysLeft > 1 ? 'days' : 'day'}`}&nbsp;
            </StyledBoldText>
            left in your free trial!&nbsp;
            <StyledUnderlineLinkText
                href='https://www.sysaid.com/personal-demo'
                target='_blank'
                data-testid='trial-book-demo'
            >
                Book a Demo
            </StyledUnderlineLinkText>
            &nbsp;or Contact us at&nbsp;&nbsp;
            <StyledLinkText
                href='tel:+1(234)5678910'
                data-testid='trial-telephone'
            >
                <TelephoneIcon className='telephone-icon' />
                &nbsp;+1 (234) 5678910
            </StyledLinkText>
        </StyledTrialBanner>
    )
}

export default TrialBanner;